var map = {
	"./arrow-dropdown.svg": 7375,
	"./arrow-select.svg": 4836,
	"./btn-arrow-orange.svg": 2114,
	"./btn-arrow.svg": 5240,
	"./clock.svg": 3090,
	"./cookies.svg": 5058,
	"./facebook-icon-new.svg": 9614,
	"./facebook.svg": 8528,
	"./instagram-icon-new.svg": 6083,
	"./instagram.svg": 4443,
	"./phone-icon.svg": 4890,
	"./phone.svg": 350,
	"./search.svg": 3225,
	"./surface.svg": 1556,
	"./text-symbol.svg": 2487,
	"./video-play.svg": 4711,
	"./weather-big-clouds.svg": 7657,
	"./weather-big-rain.svg": 8827,
	"./weather-fog.svg": 1280,
	"./weather-small-clouds.svg": 207,
	"./weather-small-rain.svg": 8564,
	"./weather-storm.svg": 9419,
	"./weather-sunny.svg": 4740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;